<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import { mapTime } from "@/api/map.js";
import Chart from "./chart.vue";
export default {
  data() {
    return {
      cdata: [
//  {
// 		"name": "北京",
// 		"value": 604
// 	}, {
// 		"name": "天津",
// 		"value": 292
// 	}, {
// 		"name": "河北",
// 		"value": 73
// 	}, {
// 		"name": "山西",
// 		"value": 61
// 	}, {
// 		"name": "内蒙古",
// 		"value": 70
// 	}, {
// 		"name": "辽宁",
// 		"value": 38
// 	}, {
// 		"name": "吉林",
// 		"value": 54
// 	}, {
// 		"name": "黑龙江",
// 		"value": 65
// 	}, {
// 		"name": "上海",
// 		"value": 316
// 	}, {
// 		"name": "江苏",
// 		"value": 133
// 	}, {
// 		"name": "浙江",
// 		"value": 125
// 	}, {
// 		"name": "安徽",
// 		"value": 321
// 	}, {
// 		"name": "福建",
// 		"value": 196
// 	}, {
// 		"name": "江西",
// 		"value": 145
// 	}, {
// 		"name": "山东",
// 		"value": 249
// 	}, {
// 		"name": "河南",
// 		"value": 232
// 	}, {
// 		"name": "湖北",
// 		"value": 220
// 	}, {
// 		"name": "湖南",
// 		"value": 121
// 	}, {
// 		"name": "广东",
// 		"value": 53
// 	}, {
// 		"name": "广西",
// 		"value": 104
// 	}, {
// 		"name": "海南",
// 		"value": 43
// 	}, {
// 		"name": "重庆",
// 		"value": 128
// 	}, {
// 		"name": "四川",
// 		"value": 201
// 	}, {
// 		"name": "贵州",
// 		"value": 78
// 	}, {
// 		"name": "云南",
// 		"value": 110
// 	}, {
// 		"name": "西藏",
// 		"value": 47
// 	}, {
// 		"name": "陕西",
// 		"value": 198
// 	}, {
// 		"name": "甘肃",
// 		"value": 50
// 	}, {
// 		"name": "青海",
// 		"value": 141
// 	}, {
// 		"name": "宁夏",
// 		"value": 23
// 	}, {
// 		"name": "新疆",
// 		"value": 89
// 	}, {
// 		"name": "台湾",
// 		"value": 58
// 	}, {
// 		"name": "香港",
// 		"value": 3
// 	}, {
// 		"name": "澳门",
// 		"value": 2
// 	}
 
      ],
    };
  },
  components: {
    Chart,
  },
  created(){
    this.lond()
  },
  mounted() {},
  methods: {
    lond(){
      mapTime().then(res=>{
        this.cdata=res.data.data
        // console.log(res)
      })
    }
  },
};
</script>

<style lang="scss" scoped></style>
